import { render, staticRenderFns } from "./stockCuList.vue?vue&type=template&id=6626da20&scoped=true"
import script from "./stockCuList.vue?vue&type=script&lang=js"
export * from "./stockCuList.vue?vue&type=script&lang=js"
import style0 from "./stockCuList.vue?vue&type=style&index=0&id=6626da20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6626da20",
  null
  
)

export default component.exports